import { t } from 'libs/translations';

export const importProposalErrorPhrases = {
  noMetaKey: t('errors.noMetaKey'),
  noSignaturesKey: t('errors.noSignaturesKey'),
  noTypeKey: t('errors.noTypeKey'),
  noTargetsKey: t('errors.noTargetsKey'),
  noParamsKey: t('errors.noParamsKey'),
  missingTitle: t('errors.missingTitle'),
  missingTargetForSignature: t('errors.missingTargetForSignature'),
  missingParamsForSignature: t('errors.missingParamForSignature'),
  missingDescription: t('errors.missingDescription'),
  missingForDescription: t('errors.missingForDescription'),
  missingAgainstDescription: t('errors.missingAgainstDescription'),
  missingAbstainDescription: t('errors.missingAbstainDescription'),
  validationError: t('errors.validationError'),
};
